<!-- Head -->
<ng-template #dialogHead>
    <label class="label-title">Create Product Rate Plan From Templates</label>
    <button mat-icon-button mat-dialog-close class="custom-mat-icon-button button-close-panel">
      <mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
    </button>
  </ng-template>
  <!-- Body -->
  <ng-template #dialogBody>
    <div class="form-row px-10">
    <app-template-selector [hideNew]="true" (selectedTemplate)="onSelectTemplate($event)" class="size size1of1"></app-template-selector>
</div>
  </ng-template>
  <!-- Nav -->
  <ng-template #dialogNav>
    <button mat-flat-button [disabled]="selectedTemplateCtrl.invalid" (click)="onSubmit()" color="primary" class="mat-button custom-mat-button-primary">Add</button>
  </ng-template>

  <app-dialog
    [dialogHead]="dialogHead"
    [dialogBody]="dialogBody"
    [dialogNav]="dialogNav">
  </app-dialog>
